import generalLedgers from './general-ledgers.js';
import entity from './entity.js';
import expenses from './expenses.js';
import invoices from './invoices.js';
import progressReports from './progress-reports.js';
import inventory from './inventory.js';
import taxes from './taxes.js';
import accounting from './accounting.js';
import payroll from './payroll.js';

export default [...accounting, ...generalLedgers, ...inventory, ...progressReports, ...expenses, ...entity, ...invoices, ...taxes, ...payroll];
